export default "__VITE_ASSET__nDardfK8__"